'use client';

import { useCallback, useState } from 'react';

export function useFocusWithin(): [boolean, () => void, () => void, (value: boolean) => void] {
  const [isFocusWithin, setIsFocusWithin] = useState(false);
  const handleFocus = useCallback(() => {
    setIsFocusWithin(true);
  }, []);
  const handleBlur = useCallback(() => {
    const timer = window.setTimeout(() => {
      setIsFocusWithin(false);
    }, 150);

    return () => {
      window.clearTimeout(timer);
    };
  }, []);

  return [isFocusWithin, handleFocus, handleBlur, setIsFocusWithin];
}
